import angular from 'angular';
import uiRouter from 'angular-ui-router';
import angularOAuth2 from 'angular-oauth2';

import authConfig from './auth.config';
import authRun from './auth.run';
import authService from './auth.service';

const authModule = angular.module('authService', [
        uiRouter,
        angularOAuth2.name
    ])
    .config(authConfig)
    .run(authRun)
    .service('authService', authService)
    .name;

export default authModule;



// WEBPACK FOOTER //
// ./client/app/common/auth/auth.js